var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1421_1009)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1421_1009",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0.394531H0V23.5056H24V0.394531Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1421_1009)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2339 10.1805L22.9764 0.394531H20.9047L13.3136 8.89152L7.25071 0.394531H0.257812L9.42618 13.2435L0.257812 23.5057H2.32961L10.3459 14.5325L16.7488 23.5057H23.7417L14.2339 10.1805ZM11.3963 13.3568L10.4674 12.0773L3.0761 1.89638H6.25825L12.2231 10.1127L13.152 11.3921L20.9056 22.0721H17.7235L11.3963 13.3568Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1421_1009"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.88d2f82bb07057be1ea078662f632336.svg";
export { ForwardRef as ReactComponent };